<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" :model="searchForm" label-width="100px" ref="searchForm">
          <el-form-item label="产品编码">
            <el-input v-model.trim="searchForm.productCode" placeholder="请输入产品编码"></el-input>
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input v-model.trim="searchForm.productName" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="产品型号">
            <el-input v-model.trim="searchForm.bigModel" placeholder="请输入产品型号"></el-input>
          </el-form-item>
          <el-form-item label="产品生命周期">
            <el-select v-model="searchForm.productStatusList" multiple collapse-tags>
              <el-option v-for="item in productionStatus" :label="item.label" :key="item.value" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品类">
            <el-select v-model="searchForm.category" filterable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in orderStatusList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售等级">
            <el-select v-model="searchForm.saleLocation" filterable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in positioning" :label="item.val" :key="item.val" :value="item.val"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否滞销">
            <el-select v-model="searchForm.unsoldFlag">
              <el-option label="全部" value="">全部</el-option>
              <el-option label="是" value="1">是</el-option>
              <el-option label="否" value="0">否</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款时间">
            <form-month-range
              :form="searchForm"
              startKey="payDateStart"
              endKey="payDateEnd"
              :usingTime="false"
              valueFormat="yyyy-MM"
              :pickerOptions="pickerOptionsMonth"
              dateType="month"
            ></form-month-range>
          </el-form-item>
          <el-form-item label="上市时间">
            <form-date-range
              :form="searchForm"
              startKey="upDateStart"
              endKey="upDateEnd"
              :usingTime="false"
              valueFormat="yyyy-MM-dd"
              :pickerOptions="pickerOptionsYearMonth"
            ></form-date-range>
          </el-form-item>
          <el-form-item label="标签">
            <el-select v-model="searchForm.label">
              <el-option label="全部" value="">全部</el-option>
              <el-option label="清仓" value="清仓">清仓</el-option>
              <el-option label="休闲" value="休闲">休闲</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺">
            <el-select
              v-model="searchForm.shopIdList"
              @change="storeOptionsChange"
              ref="select"
              filterable
              collapse-tags
              multiple
              reserve-keyword
            >
              <el-option v-if="!all" label="全部" value=""></el-option>
              <el-option v-if="all" label="取消所有" value="cancleAll"></el-option>
              <el-option
                v-for="item in storeCodeData.filter((v) => v)"
                :label="item.val"
                :key="item.key"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类别">
            <el-select v-model="searchForm.typeName">
              <el-option label="整体" value=""></el-option>
              <el-option
                v-for="item in productCategoryData.productType"
                :label="item.content"
                :key="item.content"
                :value="item.content"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金额/销量">
            <el-checkbox-group v-model="searchForm.showTypeList" @change="selectList(1)">
              <el-checkbox
                label="saleamount"
                v-if="columnJurisdiction"
                :disabled="searchForm.showTypeList.length == 1 && searchForm.showTypeList[0] == 'saleamount'"
              >金额</el-checkbox>
              <el-checkbox
                label="salenum"
                :disabled="!columnJurisdiction || (searchForm.showTypeList.length == 1 && searchForm.showTypeList[0] == 'salenum')"
              >销量</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="selectList">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button
          type="primary"
          size="mini"
          @click="uploadForm"
          v-permission="'ec-pc-new$reportCenter$productData$lifeCycleManagement$BigModelEdit'"
        >编辑</el-button>
        <el-button
          type="primary"
          class="green-btn"
          size="mini"
          @click="onExport"
          v-loading.fullscreen.lock="loadingExport"
          element-loading-text="数据导出中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >导出</el-button>
        <el-button
          type="primary"
          class="green-btn"
          size="mini"
          @click="importExcel"
          v-permission="'ec-pc-new$reportCenter$productData$lifeCycleManagement$BigModelimport'"
        >导入</el-button>
        <el-button type="primary" size="mini" @click="tableVisible = true">表格设置</el-button>
      </template>

      <el-table
        :data="tableData.content"
        v-loading="loading"
        v-if="tableReload"
        border
        :height="maxTableHeight"
        highlight-current-row
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChange"
        :header-cell-style="{
          backgroundColor: '#FAFAFA',
        }"
        :row-key="
          (row) => {
            return row.pagehelper_row_id;
          }
        "
        style="width: 100%"
        ref="table"
      >
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          :fixed="item.fixed"
          :min-width="item.width"
          :sortable="item.sortable ? 'custom' : false"
          show-overflow-tooltip
          v-for="item in columnData"
          :key="item.prop"
          :align="item.label == '产品编码' || item.label == '产品名称' || item.label == '图片' ? 'left' : 'right'"
        >
          <template slot="header">
            <template v-if="item.label.includes('销量')">
              <span>{{ item.label }}</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <span class="el-icon-question"></span>
                <div slot="content">包含京东入仓销量</div>
              </el-tooltip>
            </template>
          </template>
          <template slot-scope="scope">
            <template v-if="item.label === '图片'">
              <template v-if="showDetailBtn(scope.row)">
                <el-link :underline="false" type="primary" @click="showDialog(scope.row, 0)">查看</el-link>
              </template>
            </template>
            <template v-else-if="item.label === '月均销量' || item.label === '月均销售额'">
              {{ Number(scope.row[item.prop]).toLocaleString() }}
            </template>
            <template v-else-if="item.label.includes('年') && searchForm.shopIdList.length != 1">
              <el-link :underline="false" type="primary" @click="salesVolume(scope)">{{
                Number(scope.row[item.prop]).toLocaleString()
              }}</el-link>
            </template>
            <template v-else>
              {{ scope.row[item.prop] }}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="operationRecord" label="操作" fixed="right" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-link :underline="false" type="primary" @click="showjournal(scope.row)">查看日志</el-link>
          </template>
        </el-table-column>
      </el-table>

      <template v-slot:footer>
        <div class="footer-box">
          <div class="time-text">
            <span>{{ timeText.updateContent ? "数据刷新时间：" : "" }}</span>
            <span>{{ timeText.latestUpdateTime ? timeText.latestUpdateTime : "" }}</span>
          </div>
          <el-pagination
            @size-change="operationSizeChange"
            @current-change="operationCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            :total="tableData.total"
            background
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>

    <!-- 编辑弹框 -->
    <edit-opinion-dialog
      :visible.sync="addDialogVisible"
      :selectSpus="selectSpus"
      @success="onEditSuccess"
    />

    <!-- 销量情况 -->
    <sales-volume-dialog
      :visible.sync="salesVolumeDialogVisible"
      :scope="currentScope"
      :searchForm="searchForm"
    />

    <!-- 调整记录 -->
    <adjust-record-dialog
      :visible.sync="recordDialogVisible"
      :row="currentRow"
    />

    <!-- 视频、图片查看 -->
    <pic-video v-model="picVideoVisible" :data="rowData" :detailType="viewType" v-if="picVideoVisible"></pic-video>
    <!-- 自定义列 -->
    <custom-table
      v-model="tableVisible"
      :tableDataSet="tableDataSet"
      v-if="tableVisible"
      @closeAddForm="customForm"
      @confirm="confirm"
    ></custom-table>
  </content-panel>
</template>

<script>
import { debounce } from "@/utils/index";
import picVideoMxin from "./pic&video.mixin";
import importExportMxin from "./import&export.mixin";
import customProps from "../customProps.mixin";
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin'
import moment from "moment";
import axios from "@/utils/axiosInstance";
import EditOpinionDialog from './components/edit-opinion-dialog.vue'
import SalesVolumeDialog from './components/sales-volume-dialog.vue'
import AdjustRecordDialog from './components/adjust-record-dialog.vue'

export default {
  mixins: [picVideoMxin, importExportMxin, customProps, pagePathMixin, tableMixin],
  components: {
    EditOpinionDialog,
    SalesVolumeDialog,
    AdjustRecordDialog
  },
  name: "ProductDetails",
  data() {
    return {
      loadingExport: false,
      loading: false,
      addDialogVisible: false,
      recordDialogVisible: false,
      salesVolumeDialogVisible: false,
      stores: [],
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      searchForm: {
        sortField: "",
        sortOptions: "",
      },
      onRemoveSpuIds: [],
      productionStatus: [],
      positioning: [],
      selectSpus: [],
      exportForm: {},
      tableReload: true,
      orderStatusList: [],
      pickerOptionsMonth: this.banTime(),
      pickerOptionsYearMonth: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      lastParams: {},
      storeCodeData: [],
      productCategoryData: [],
      all: false,
      reportName: "ProductSalesDetails",
      timeText: {},
      currentRow: null,
      currentScope: null,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [],
        orderList: [],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  watch: {
    $route: {
      handler(val, olv) {
        if (
          (olv.path == "/largeSizeDetails" ||
            olv.path == "/newProduct/lifeCycleManagement" ||
            olv.path == "/productLifeCycle/administration") &&
          (val.params.bigModel !== this.lastParams.bigModel ||
            val.params.category !== this.lastParams.category ||
            val.params.typeName !== this.lastParams.typeName ||
            val.params.categoryType !== this.lastParams.categoryType ||
            val.params.saleLocation !== this.lastParams.saleLocation ||
            val.params.unsoldFlag !== this.lastParams.unsoldFlag) &&
          JSON.stringify(val.params) != "{}"
        ) {
          // console.log(val.params);
          this.tableData.pageNum = 1;
          this.$set(this.searchForm, "bigModel", val.params.bigModel);
          this.$set(this.searchForm, "category", val.params.category);
          this.$set(this.searchForm, "categoryType", val.params.categoryType);
          this.$set(this.searchForm, "unsoldFlag", val.params.unsoldFlag);
          this.$set(this.searchForm, "typeName", val.params.typeName);
          this.$set(this.searchForm, "saleLocation", val.params.saleLocation);
          this.$set(this.searchForm, "showTypeList", this.columnJurisdiction ? ["saleamount", "salenum"] : ["salenum"]);
          this.$set(this.searchForm, "payDateStart", moment(new Date()).subtract(6, "months").format("YYYY-MM"));
          this.$set(this.searchForm, "payDateEnd", moment(new Date()).subtract(1, "months").format("YYYY-MM"));
          this.refreshTime();
          this.productCategory();
          this.unsaleOrderType();
          this.queryMarketingPositioning();
          this.queryProductionStatus();
          this.orderStatus();
          this.onSearch();
        }
        this.lastParams = val.params;
      },
      deep: true,
    },
  },

  mounted() {
    this.refreshTime();
    this.productCategory();
    this.unsaleOrderType();
    this.queryMarketingPositioning();
    this.queryProductionStatus();
    this.orderStatus();
    setTimeout(() => {
      this.$set(this.searchForm, "bigModel", this.$route.params.bigModel);
      this.$set(this.searchForm, "category", this.$route.params.category);
      this.$set(this.searchForm, "categoryType", this.$route.params.categoryType);
      this.$set(this.searchForm, "unsoldFlag", this.$route.params.unsoldFlag);
      this.$set(this.searchForm, "typeName", this.$route.params.typeName);
      this.$set(this.searchForm, "saleLocation", this.$route.params.saleLocation);
      this.$set(this.searchForm, "productStatusList", ['E','F','G']);
      this.$set(this.searchForm, "showTypeList", this.columnJurisdiction ? ["saleamount", "salenum"] : ["salenum"]);
      this.$set(this.searchForm, "payDateStart", moment(new Date()).subtract(6, "months").format("YYYY-MM"));
      this.$set(this.searchForm, "payDateEnd", moment(new Date()).subtract(1, "months").format("YYYY-MM"));
      this.onSearch();
      this.$nextTick(() => {
        this.setMaxHeight();
      });
    }, 200);
  },
  methods: {
    // 大于当前月分的日期不可选
    banTime() {
      return {
        disabledDate(time) {
          const date = new Date();
          const year = date.getFullYear();
          let month = date.getMonth();
          if (month >= 1 && month <= 9) {
            month = "0" + month;
          }
          const currentdate = year.toString() + month.toString();
          const timeyear = time.getFullYear();
          let timemonth = time.getMonth();
          if (timemonth >= 1 && timemonth <= 9) {
            timemonth = "0" + timemonth;
          }
          const timedate = timeyear.toString() + timemonth.toString();
          return currentdate <= timedate;
        },
      };
    },
    getRowKeys(row) {
      return row.index;
    },
    uploadForm() {
      if (this.selectSpus.length == 0) {
        this.$message.error("请选择具体的产品型号");
        return;
      }
      this.addDialogVisible = true;
      this.titleName = "处理意见";
    },
    orderStatus() {
      this.$q.newProduct.getCategory({}).then((data) => {
        if (data.code === "200") {
          this.orderStatusList = data.data.productCateGory;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    onEditSuccess() {
      this.$refs.table.clearSelection();
      this.selectSpus = [];
      this.onSearch();
    },
    handleSelectionChange(val) {
      this.onRemoveSpuIds = [];
      console.log("val", val);
      val.forEach((x) => {
        this.onRemoveSpuIds.push(x.id);
      });
      this.selectSpus = val;
      console.log(this.selectSpus);
    },
    salesVolume(scope) {
      this.currentScope = scope;
      this.salesVolumeDialogVisible = true;
    },
    showjournal(row) {
      this.currentRow = row;
      this.recordDialogVisible = true;
    },
    resetSearchForm() {
      (this.searchForm = {
        payDateStart: moment(new Date()).subtract(6, "months").format("YYYY-MM"),
        payDateEnd: moment(new Date()).subtract(1, "months").format("YYYY-MM"),
        productStatusList: ['E','F','G'],
        shopIdList: [],
        showTypeList: this.columnJurisdiction ? ["saleamount", "salenum"] : ["salenum"],
      }),
        this.$refs.table.clearSelection();
      this.$refs.table.clearSort();
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    selectList(type) {
      if (type == 1) {
        this.searchForm.sortField = "";
        this.searchForm.sortOptions = "";
      }
      this.$refs.table.clearSort();
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onSearch(type) {
      this.loading = true;
      const param = {
        num: this.tableData.pageNum,
        size: this.tableData.pageSize,
        ...this.searchForm,
      };
      this.exportForm = param;
      this.productSelectStoreBox();
      this.$q.productModelDetails
        .productCycleSaleDetail({ data: JSON.stringify(param) })
        .then((res) => {
          if (res.code == 200) {
            if (!type) {
              this.pagingColumnData = res.data.keyVoList;
              this.customColumn();
            }
            this.tableData = res.data;
          }
        })
        .finally((res) => {
          this.loading = false;
        });
    },
    operationSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      // 切换每页条数后从第一页搜索
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    operationCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.onSearch();
    },

    importExcel() {
      this.openSubPage({
        //核心语句
        path: "/ProductDetailsImport",
        // name: 'importexcelbyspu',   //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          // fileType: '18',
          fileName: "产品处理意见导入.xlsx",
          appCode: "ec-pc-new",
        },
      });
    },
    onCollapse() {
      if (this.formHeight === "45px") {
        this.formHeight = "auto";
      } else {
        this.formHeight = "45px";
      }
      this.tableReload = false;
      this.$nextTick((_) => {
        this.tableReload = true;
      });
    },

    storeOptionsChange(val) {
      if (val.includes("")) {
        this.searchForm.shopIdList = this.storeCodeData.map((v) => v.key);
        this.all = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.shopIdList = [];
        this.all = false;
      }
      this.$refs.select.query = "";
    },

    productSelectStoreBox() {
      this.$q.productModelDetails.productSelectStoreBox({ data: this.exportForm }).then((data) => {
        if (data.code === "200") {
          this.storeCodeData = data.data;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    unsaleOrderType() {
      this.$q.productModelDetails.queryMarketingCategory({}).then((data) => {
        if (data.code === "200") {
          this.unsaleOrderTypeList = data.data;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    queryMarketingPositioning() {
      this.$q.productModelDetails.productCodeMarketingPositioning({}).then((data) => {
        if (data.code === "200") {
          this.positioning = data.data;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    queryProductionStatus() {
      let data = {...this.currencyForm}
      data.reportCode = 'commonProductStateList'
      axios
        .post(`/ec-pc-api/custom/reports/data/commonProductStateList`, data)
        .then((res) => {
          if (res.code == 200) {
           this.productionStatus = res.data.list.map(v => {
             return {
               ...v,
               value: v.proState,
               label: v.proStateDesc
             }
           })
          }
        })
    },
    async refreshTime() {
      let res = await this.$q.common.refreshTime({ fragment: [55] });
      this.timeText = res.data;
    },
    productCategory() {
      this.$q.newProduct.options({}).then((res) => {
        this.productCategoryData = res.data;
      });
    },
    handleSortChange({ column, prop, order }) {
      this.tableData.pageNum = 1;
      this.searchForm.sortField = prop;
      (this.searchForm.sortOptions = order === "ascending" ? "0" : order === "descending" ? "1" : ""), this.onSearch(true);
    },
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input, >>> .el-autocomplete, >>> .el-checkbox-group
    width 240px !important

>>> .date-range .single-date
  width 110px !important

.footer-box
  display flex
  justify-content space-between
  align-items center
  .time-text
    color #555555

.el-input-group__append button.el-button, .el-input-group__append div.el-select .el-input__inner, .el-input-group__append div.el-select:hover .el-input__inner, .el-input-group__prepend button.el-button, .el-input-group__prepend div.el-select .el-input__inner, .el-input-group__prepend div.el-select:hover .el-input__inner
  border-color: #0BB78E
  background-color: #0BB78E
  color: #FFF
  border-top: 0
  border-bottom: 0

.ant-divider, .ant-divider-vertical
  position: relative
  top: -.06em
  display: inline-block
  width: 1px
  height: .8em
  margin: 0 6px
  vertical-align: middle
  background-color: #0BB78E

.avatar-uploader
  >>> .el-upload
    border: 1px dashed #d9d9d9
    border-radius: 6px
    cursor: pointer
    position: relative
    overflow: hidden

    &:hover
      border-color: #409EFF

.avatar-uploader-icon
  font-size: 28px
  color: #8c939d
  width: 150px
  height: 150px
  line-height: 150px
  text-align: center

.avatar
  width: 150px
  height: 150px
  display: block

.upload-tip
  margin-left 30px
  margin-top -10px

.preview-content
  text-align center

  p
    margin-bottom 10px

  >>> .el-image
    width 200px
    height 200px

>>> .el-dialog__body
  padding 10px 15px

>>> .el-table__expanded-cell
  padding 10px
  background rgb(250, 250, 250)

.dialog-footer
  text-align center

>>> .input .el-input__inner
  width 150px
  height 28px

>>> .el-form .el-select__tags-text
  display: inline-block
  max-width: 93px
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap

>>> .el-select .el-tag__close.el-icon-close
  top: 0px
</style>
